<div class="spinner-container" *ngIf="loading && !isEmbedded">
  <fa-icon [icon]="['fas', 'spinner']" [pulse]="true" size="4x" class="spinner mx-auto align-middle"></fa-icon>
</div>
<iframe #iframe title="pdf"></iframe>
